<template>
  <div class="contnet-titleback" :style="{ width: width }">
    <img
      :src="iconSrc"
      alt=""
      class="top-titleview-leftimg"
    />
    <div class="titleback-rightStr">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'TitleBar',
  props: {
    text: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: () => require('@/assets/images/homepage_title01.png')
    },
    width: {
      type: String,
      default: '950px'
    }
  },
  computed: {
    iconSrc () {
      return this.icon
    }
  }
}
</script>

<style scoped lang="less">
.contnet-titleback {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 240px;
  justify-content: flex-start;
}
.top-titleview-leftimg {
  width: 30px;
  height: 30px;
}
.titleback-rightStr {
  margin-left: 10px;
  font-size: 24px;
  text-align: left;
  color: #040404;
  font-weight: 600;
}
</style>
